// Hooks
export { useCurriculumSearch } from './hooks'
export {
  useCurriculumCache,
  getCachedCurriculum,
  setCachedCurriculum,
  clearCurriculumCache
} from './hooks'

// Utils
export { filterCurriculumTree, getAllLv4Items, containsNormalized, normalizeText } from './utils'

// Types
export type {
  TreeSearchResult,
  SearchMetadata,
  SearchOptions,
  ILvl1Item,
  ILvl2Item,
  ILvl3Item,
  ILvl4Item
} from './types'

// Constants
export {
  MIN_SEARCH_CHARS,
  SEARCH_DEBOUNCE_MS,
  MAX_SEARCH_RESULTS,
  CACHE_KEY_PREFIX,
  CACHE_TTL_MS
} from './constants'
